import script from "./UnitModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnitModal.vue?vue&type=script&setup=true&lang=ts"

import "./UnitModal.vue?vue&type=style&index=0&id=2e878b03&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_adffa71ddd91625d5265099a5205ae8f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e878b03"]])

export default __exports__